<template>
  <div>
    <FormComponent
      @searchForm="getFormData"
      :searchFormItem="formItem"
      :labelWidth="100"
      ref="FormComponent"
      @handleReset="handleReset"
    >
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot1">
        <FormItem label="" :label-width="0">
          <RadioGroup
            v-model="formItem.achStage"
            style="display: flex; justify-content: space-between"
          >
            <Radio label="目标设定"
              ><!-- 目标设定 -->{{ $t("Objective_Setting") }}</Radio
            >
            <Radio label="阶段回顾"
              ><!-- 阶段回顾 -->{{ $t("Phase_Review") }}</Radio
            >
            <Radio label="年终总结"
              ><!-- 年终总结 -->{{ $t("End-Year_Review_Over") }}</Radio
            >
          </RadioGroup>
        </FormItem>
      </Col>
      <Col
        :xs="24"
        :sm="24"
        :md="12"
        :lg="6"
        slot="slot2"
      >
        <FormItem :label="$t('Management_Level')"
          ><!-- 管理层级 -->
          <Select v-model="formItem.hrmanage" clearable>
            <Option
              v-for="item in ManagementLevel"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
    </FormComponent>
    <Table
      border
      :loading="loading"
      :columns="columns"
      :data="data"
      style="margin: 20px 0"
      v-show="searchItem.year < 2025"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="checkBtn(row, index)"
        ></Button>
      </template>
    </Table>
    <Table
      border
      :loading="loading"
      :columns="columnsGrowthCulture"
      :data="dataGrowth"
      style="margin: 20px 0"
      v-show="searchItem.year == 2025"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="checkBtn(row, index)"
        ></Button>
      </template>
    </Table>
    <Table
      border
      :loading="loading"
      :columns="columnsGrowthCulture26"
      :data="dataGrowth26"
      style="margin: 20px 0"
      v-show="searchItem.year >= 2026"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          @click="checkBtn(row, index)"
        ></Button>
      </template>
    </Table>
    <Table
      border
      :loading="loading"
      :columns="columnsA"
      :data="dataA"
      style="margin: 20px 0"
      ref="tableRef"
      v-show="false"
    ></Table>
    <Table
      border
      :loading="loading"
      :columns="columnsAGrowthCulture"
      :data="dataGrowthA"
      style="margin: 20px 0"
      ref="tableGrowthRef"
      v-show="false"
    ></Table>
    <Table
      border
      :loading="loading"
      :columns="columnsAGrowthCulture26"
      style="margin: 20px 0"
      ref="tableGrowth26Ref"
      v-show="false"
    ></Table>
    <div
      style="
        margin: 20px 0;
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
        align-items: flex-end;
      "
    >
      <Page
        :total="total"
        :current="pageInfo.pageNo"
        :page-size="pageInfo.pageSize"
        transfer
        @on-change="pageChange"
        :page-size-opts="[50, 100, 150, 200]"
        show-sizer
        @on-page-size-change="pageSizeChange"
      />
      <!--  :page-size-opts="searchItem.year >= 2025 ? [50, 100, 150, 200] :  [30, 60, 90, 120] " -->
      <Button type="primary" style="margin-top: 15px" @click="exportData"
        ><!-- 导出 -->{{ $t("PB_Export") }}</Button
      >
    </div>
  </div>
</template>

<script>
import FormComponent from "./FormComponent.vue";
import axios from "axios";
import DateUtil from "../../../../util/DateUtil";
export default {
  components: { FormComponent },
  data() {
    return {
      date: new DateUtil(),
      loading: false,
      formItem: {
        achStage: "目标设定",
      },
      searchItem: {},
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 50,
      },
      total: 0,
      data: [],
      dataA: [],
      dataGrowth: [],
      dataGrowthA: [],
      columnsGrowthCulture26: [],
      columnsAGrowthCulture26: [],
      dataGrowth26: [],
      flag26: false,
      ManagementLevel: [],
    };
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    columns() {
      return [
        {
          title: this.$t("Check") /* 查看 */,
          slot: "action",
          align: "center",
          minWidth: 70,
          fixed: "left",
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 100,
          fixed: "left",
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 100,
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 80,
        },
        {
          title: this.$t("longText35") /* 达成目标过程中的行为期望(员工说明) */,
          align: "center",
          children: [
            {
              title: this.$t("Alignment") /* 协同一致 */,
              key: "expectDetails1",
              align: "center",
              minWidth: 260,
            },
            {
              title: this.$t("Accountability_") /* 勇于承担 */,
              key: "expectDetails2",
              align: "center",
              minWidth: 260,
            },
            {
              title: this.$t("Action_Ach") /* 付诸行动 */,
              key: "expectDetails3",
              align: "center",
              minWidth: 260,
            },
          ],
        },
        {
          title: this.$t("Line_Manager_Feedback") /* 经理反馈 */,
          align: "center",
          children: [
            {
              title: this.$t("Alignment") /* 协同一致 */,
              key: "dirSupFeedback1",
              align: "center",
              minWidth: 260,
            },
            {
              title: this.$t("Accountability_") /* 勇于承担 */,
              key: "dirSupFeedback2",
              align: "center",
              minWidth: 260,
            },
            {
              title: this.$t("Action_Ach") /* 付诸行动 */,
              key: "dirSupFeedback3",
              align: "center",
              minWidth: 260,
            },
          ],
        },
        {
          title: this.$t("Dotted-Line_Manager_Feedback") /* 经理反馈 */,
          align: "center",
          children: [
            {
              title: this.$t("Alignment") /* 协同一致 */,
              key: "indirSupFeedback1",
              align: "center",
              minWidth: 260,
            },
            {
              title: this.$t("Accountability_") /* 勇于承担 */,
              key: "indirSupFeedback2",
              align: "center",
              minWidth: 260,
            },
            {
              title: this.$t("Action_Ach") /* 付诸行动 */,
              key: "indirSupFeedback3",
              align: "center",
              minWidth: 260,
            },
          ],
        },
      ];
    },
    columnsGrowthCulture() {
      return [
        {
          title: this.$t("Check") /* 查看 */,
          slot: "action",
          align: "center",
          minWidth: 70,
          fixed: "left",
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 100,
          fixed: "left",
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 100,
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 80,
        },
        {
          title: this.$t("longText35") /* 达成目标过程中的行为期望(员工说明) */,
          align: "center",
          children: [
            {
              title:
                this.$t(
                  "growthCulture1"
                ) /* 我们永怀炽热之心，不断追求卓越表现 */,
              key: "expectDetails1",
              align: "center",
              minWidth: 260,
            },
            {
              title:
                this.$t(
                  "growthCulture2"
                ) /* 我们营造一个充满正能量、具有同理心的工作环境 */,
              key: "expectDetails2",
              align: "center",
              minWidth: 260,
            },
            {
              title:
                this.$t(
                  "growthCulture3"
                ) /* 我们所做的一切始终以消费者为中心 */,
              key: "expectDetails3",
              align: "center",
              minWidth: 260,
            },
            {
              title: this.$t("growthCulture4") /* 我们快速决策，卓越交付 */,
              key: "expectDetails4",
              align: "center",
              minWidth: 260,
            },
            {
              title:
                this.$t(
                  "growthCulture5"
                ) /* 我们赋能、授权、支持和培养我们的员工，使其充分发挥潜力 */,
              key: "expectDetails5",
              align: "center",
              minWidth: 260,
            },
          ],
        },
        {
          title: this.$t("Employee_Self-Evaluation") /* 员工自评 */,
          align: "center",
          children: [
            {
              title:
                this.$t(
                  "growthCulture1"
                ) /* 我们永怀炽热之心，不断追求卓越表现 */,
              key: "empDetails1",
              align: "center",
              minWidth: 260,
            },
            {
              title:
                this.$t(
                  "growthCulture2"
                ) /* 我们营造一个充满正能量、具有同理心的工作环境 */,
              key: "empDetails2",
              align: "center",
              minWidth: 260,
            },
            {
              title:
                this.$t(
                  "growthCulture3"
                ) /* 我们所做的一切始终以消费者为中心 */,
              key: "empDetails3",
              align: "center",
              minWidth: 260,
            },
            {
              title: this.$t("growthCulture4") /* 我们快速决策，卓越交付 */,
              key: "empDetails4",
              align: "center",
              minWidth: 260,
            },
            {
              title:
                this.$t(
                  "growthCulture5"
                ) /* 我们赋能、授权、支持和培养我们的员工，使其充分发挥潜力 */,
              key: "empDetails5",
              align: "center",
              minWidth: 260,
            },
          ],
        },
        {
          title: this.$t("Line_Manager_Feedback") /* 经理反馈 */,
          align: "center",
          children: [
            {
              title:
                this.$t(
                  "growthCulture1"
                ) /* 我们永怀炽热之心，不断追求卓越表现 */,
              key: "dirSupFeedback1",
              align: "center",
              minWidth: 260,
            },
            {
              title:
                this.$t(
                  "growthCulture2"
                ) /* 我们营造一个充满正能量、具有同理心的工作环境 */,
              key: "dirSupFeedback2",
              align: "center",
              minWidth: 260,
            },
            {
              title:
                this.$t(
                  "growthCulture3"
                ) /* 我们所做的一切始终以消费者为中心 */,
              key: "dirSupFeedback3",
              align: "center",
              minWidth: 260,
            },
            {
              title: this.$t("growthCulture4") /* 我们快速决策，卓越交付 */,
              key: "dirSupFeedback4",
              align: "center",
              minWidth: 260,
            },
            {
              title:
                this.$t(
                  "growthCulture5"
                ) /* 我们赋能、授权、支持和培养我们的员工，使其充分发挥潜力 */,
              key: "dirSupFeedback5",
              align: "center",
              minWidth: 260,
            },
          ],
        },
        {
          title: this.$t("Dotted-Line_Manager_Feedback") /* 经理反馈 */,
          align: "center",
          children: [
            {
              title:
                this.$t(
                  "growthCulture1"
                ) /* 我们永怀炽热之心，不断追求卓越表现 */,
              key: "indirSupFeedback1",
              align: "center",
              minWidth: 260,
            },
            {
              title:
                this.$t(
                  "growthCulture2"
                ) /* 我们营造一个充满正能量、具有同理心的工作环境 */,
              key: "indirSupFeedback2",
              align: "center",
              minWidth: 260,
            },
            {
              title:
                this.$t(
                  "growthCulture3"
                ) /* 我们所做的一切始终以消费者为中心 */,
              key: "indirSupFeedback3",
              align: "center",
              minWidth: 260,
            },
            {
              title: this.$t("growthCulture4") /* 我们快速决策，卓越交付 */,
              key: "indirSupFeedback4",
              align: "center",
              minWidth: 260,
            },
            {
              title:
                this.$t(
                  "growthCulture5"
                ) /* 我们赋能、授权、支持和培养我们的员工，使其充分发挥潜力 */,
              key: "indirSupFeedback5",
              align: "center",
              minWidth: 260,
            },
          ],
        },
      ];
    },
    columnsA() {
      return [
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 100,
        },
        {
          title:
            this.$t("longText35") + "_" + this.$t("Alignment") /* 协同一致 */,
          key: "expectDetails1",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("longText35") +
            "_" +
            this.$t("Accountability_") /* 勇于承担 */,
          key: "expectDetails2",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("longText35") + "_" + this.$t("Action_Ach") /* 付诸行动 */,
          key: "expectDetails3",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Line_Manager_Feedback") +
            "_" +
            this.$t("Alignment") /* 协同一致 */,
          key: "dirSupFeedback1",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Line_Manager_Feedback") +
            "_" +
            this.$t("Accountability_") /* 勇于承担 */,
          key: "dirSupFeedback2",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Line_Manager_Feedback") +
            "_" +
            this.$t("Action_Ach") /* 付诸行动 */,
          key: "dirSupFeedback3",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Dotted-Line_Manager_Feedback") +
            "_" +
            this.$t("Alignment") /* 协同一致 */,
          key: "indirSupFeedback1",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Dotted-Line_Manager_Feedback") +
            "_" +
            this.$t("Accountability_") /* 勇于承担 */,
          key: "indirSupFeedback2",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Dotted-Line_Manager_Feedback") +
            "_" +
            this.$t("Action_Ach") /* 付诸行动 */,
          key: "indirSupFeedback3",
          align: "center",
          minWidth: 200,
        },
      ];
    },
    columnsAGrowthCulture() {
      return [
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 120,
          fixed: "left",
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 100,
        },
        {
          title:
            this.$t("longText35") +
            "_" +
            this.$t("growthCulture1") /* 协同一致 */,
          key: "expectDetails1",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("longText35") +
            "_" +
            this.$t("growthCulture2") /* 勇于承担 */,
          key: "expectDetails2",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("longText35") +
            "_" +
            this.$t("growthCulture3") /* 付诸行动 */,
          key: "expectDetails3",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("longText35") +
            "_" +
            this.$t("growthCulture4") /* 付诸行动 */,
          key: "expectDetails4",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("longText35") +
            "_" +
            this.$t("growthCulture5") /* 付诸行动 */,
          key: "expectDetails5",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Employee_Self-Evaluation") +
            "_" +
            this.$t("growthCulture1") /* 协同一致 */,
          key: "empDetails1",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Employee_Self-Evaluation") +
            "_" +
            this.$t("growthCulture2") /* 勇于承担 */,
          key: "empDetails2",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Employee_Self-Evaluation") +
            "_" +
            this.$t("growthCulture3") /* 付诸行动 */,
          key: "empDetails3",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Employee_Self-Evaluation") +
            "_" +
            this.$t("growthCulture4") /* 付诸行动 */,
          key: "empDetails4",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Employee_Self-Evaluation") +
            "_" +
            this.$t("growthCulture5") /* 付诸行动 */,
          key: "empDetails5",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Line_Manager_Feedback") +
            "_" +
            this.$t("growthCulture1") /* 协同一致 */,
          key: "dirSupFeedback1",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Line_Manager_Feedback") +
            "_" +
            this.$t("growthCulture2") /* 勇于承担 */,
          key: "dirSupFeedback2",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Line_Manager_Feedback") +
            "_" +
            this.$t("growthCulture3") /* 付诸行动 */,
          key: "dirSupFeedback3",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Line_Manager_Feedback") +
            "_" +
            this.$t("growthCulture4") /* 付诸行动 */,
          key: "dirSupFeedback4",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Line_Manager_Feedback") +
            "_" +
            this.$t("growthCulture5") /* 付诸行动 */,
          key: "dirSupFeedback5",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Dotted-Line_Manager_Feedback") +
            "_" +
            this.$t("growthCulture1") /* 协同一致 */,
          key: "indirSupFeedback1",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Dotted-Line_Manager_Feedback") +
            "_" +
            this.$t("growthCulture2") /* 勇于承担 */,
          key: "indirSupFeedback2",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Dotted-Line_Manager_Feedback") +
            "_" +
            this.$t("growthCulture3") /* 付诸行动 */,
          key: "indirSupFeedback3",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Dotted-Line_Manager_Feedback") +
            "_" +
            this.$t("growthCulture4") /* 付诸行动 */,
          key: "indirSupFeedback4",
          align: "center",
          minWidth: 200,
        },
        {
          title:
            this.$t("Dotted-Line_Manager_Feedback") +
            "_" +
            this.$t("growthCulture5") /* 付诸行动 */,
          key: "indirSupFeedback5",
          align: "center",
          minWidth: 200,
        },
      ];
    },
  },
  mounted() {
    // this.getData()
    // this.getListData()
    this.searchItem.year = JSON.parse(sessionStorage.getItem("userInfo")).year;
  },
  methods: {
    setColumnsGrowthCulture26() {
      let arr = [
        {
          title: this.$t("Check") /* 查看 */,
          slot: "action",
          align: "center",
          width: 70,
          fixed: "left",
          isEHide: true,
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 150,
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 150,
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 150,
        },
        {
          title: this.$t("Year") /* 年度 */,
          key: "year",
          align: "center",
          minWidth: 80,
        },
        {
          title: this.$t("longText35") /* 达成目标过程中的行为期望(员工说明) */,
          align: "center",
          isHide: !["目标设定", "阶段回顾", "年终总结"].includes(
            this.formItem.achStage
          ),
          key: "expectDetails",
          minWidth: 150,
        },
        {
          title: this.$t("Employee_Self-Evaluation") /* 员工自评 */,
          align: "center",
          isHide: !["阶段回顾", "年终总结"].includes(this.formItem.achStage),
          minWidth: 150,
          key: "empDetails",
        },
        {
          title: this.$t("Line_Manager_Feedback") /* 直线经理反馈 */,
          align: "center",
          isHide: !["阶段回顾", "年终总结"].includes(this.formItem.achStage),
          minWidth: 150,
          key: "dirSupFeedback",
        },
        {
          title: this.$t("Dotted-Line_Manager_Feedback") /* 虚线经理反馈 */,
          align: "center",
          minWidth: 150,
          isHide: !["阶段回顾", "年终总结"].includes(this.formItem.achStage),
          key: "indirSupFeedback",
        },
      ];
      this.columnsGrowthCulture26 = arr.filter((item) => !item.isHide);
      this.columnsAGrowthCulture26 = this.columnsGrowthCulture26.filter(
        (item) => !item.isEHide
      );
    },
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
        if (res) {
          this.$refs.FormComponent.positionList = res.positionList;
          this.$refs.FormComponent.departmentList = res.departmentList;
          this.$refs.FormComponent.businessUnitList = res.businessUnitList;
          this.$refs.FormComponent.salesAreaList = res.salesAreaList;
          this.$refs.FormComponent.YesOrNo = res.YesOrNo;
          this.$refs.FormComponent.BeQuit = res.BeQuit;
          this.$refs.FormComponent.Level = res.Level;
          this.$refs.FormComponent.personnelType = res.personnelType;
          this.$refs.FormComponent.functionList = res.functionList;
          this.ManagementLevel = res.ManagementLevel;
        }
      });
    },
    getData(item) {
      item ? (this.searchItem = JSON.parse(item)) : "";
      let obj = {
        serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
          .serialnumber,
        ...this.searchItem,
        ...this.pageInfo,
      };
      this.loading = true;
      if (this.searchItem.year < "2025") {
        axios.post("/achReport/selectExpectInfo", obj).then((res) => {
          if (res) {
            let list = res.data;
            let array = [];
            var hash = {};
            var i = 0;
            list.forEach(function (item) {
              var id = item.id;
              if (item.criterionType == "协同一致") {
                hash[id]
                  ? (array[hash[id] - 1].expectDetails1 = item.expectDetails) &&
                    (array[hash[id] - 1].dirSupFeedback1 =
                      item.dirSupFeedback) &&
                    (array[hash[id] - 1].indirSupFeedback1 =
                      item.indirSupFeedback)
                  : (hash[id] =
                      ++i &&
                      array.push({
                        expectDetails1: item.expectDetails,
                        dirSupFeedback1: item.dirSupFeedback,
                        indirSupFeedback1: item.indirSupFeedback,
                        ...item,
                      }));
              } else if (item.criterionType == "勇于承担") {
                hash[id]
                  ? (array[hash[id] - 1].expectDetails2 = item.expectDetails) &&
                    (array[hash[id] - 1].dirSupFeedback2 =
                      item.dirSupFeedback) &&
                    (array[hash[id] - 1].indirSupFeedback2 =
                      item.indirSupFeedback)
                  : (hash[id] =
                      ++i &&
                      array.push({
                        expectDetails2: item.expectDetails,
                        dirSupFeedback2: item.dirSupFeedback,
                        indirSupFeedback2: item.indirSupFeedback,
                        ...item,
                      }));
              } else {
                hash[id]
                  ? (array[hash[id] - 1].expectDetails3 = item.expectDetails) &&
                    (array[hash[id] - 1].dirSupFeedback3 =
                      item.dirSupFeedback) &&
                    (array[hash[id] - 1].indirSupFeedback3 =
                      item.indirSupFeedback)
                  : (hash[id] =
                      ++i &&
                      array.push({
                        expectDetails3: item.expectDetails,
                        dirSupFeedback3: item.dirSupFeedback,
                        indirSupFeedback3: item.indirSupFeedback,
                        ...item,
                      }));
              }
            });
            this.data = array;
            this.total = parseInt(res.pageInfo.total);
          }
          this.$refs.FormComponent.prevent = false;
          this.loading = false;
        });
      }
      // ["2025", "2026"].includes(this.searchItem.year)
      if (Number(this.searchItem.year) > 2024) {
        axios.post("/achReport/selectGrowthInfo", obj).then((res) => {
          if (res) {
            if (this.searchItem.year == "2025") {
              let list = res.data;
              let array = [];
              var hash = {};
              var i = 0;
              list.forEach(function (item) {
                var id = item.id;
                if (
                  item.criterionType == "我们永怀炽热之心，不断追求卓越表现"
                ) {
                  hash[id]
                    ? (array[hash[id] - 1].expectDetails1 =
                        item.expectDetails) &&
                      (array[hash[id] - 1].dirSupFeedback1 =
                        item.dirSupFeedback) &&
                      (array[hash[id] - 1].empDetails1 = item.empDetails) &&
                      (array[hash[id] - 1].indirSupFeedback1 =
                        item.indirSupFeedback)
                    : (hash[id] =
                        ++i &&
                        array.push({
                          expectDetails1: item.expectDetails,
                          dirSupFeedback1: item.dirSupFeedback,
                          indirSupFeedback1: item.indirSupFeedback,
                          empDetails1: item.empDetails,
                          ...item,
                        }));
                } else if (
                  item.criterionType ==
                  "我们营造一个充满正能量、具有同理心的工作环境"
                ) {
                  hash[id]
                    ? (array[hash[id] - 1].expectDetails2 =
                        item.expectDetails) &&
                      (array[hash[id] - 1].dirSupFeedback2 =
                        item.dirSupFeedback) &&
                      (array[hash[id] - 1].empDetails2 = item.empDetails) &&
                      (array[hash[id] - 1].indirSupFeedback2 =
                        item.indirSupFeedback)
                    : (hash[id] =
                        ++i &&
                        array.push({
                          expectDetails2: item.expectDetails,
                          dirSupFeedback2: item.dirSupFeedback,
                          indirSupFeedback2: item.indirSupFeedback,
                          empDetails2: item.empDetails,
                          ...item,
                        }));
                } else if (
                  item.criterionType == "我们所做的一切始终以消费者为中心"
                ) {
                  hash[id]
                    ? (array[hash[id] - 1].expectDetails3 =
                        item.expectDetails) &&
                      (array[hash[id] - 1].dirSupFeedback3 =
                        item.dirSupFeedback) &&
                      (array[hash[id] - 1].empDetails3 = item.empDetails) &&
                      (array[hash[id] - 1].indirSupFeedback3 =
                        item.indirSupFeedback)
                    : (hash[id] =
                        ++i &&
                        array.push({
                          expectDetails3: item.expectDetails,
                          dirSupFeedback3: item.dirSupFeedback,
                          indirSupFeedback3: item.indirSupFeedback,
                          empDetails3: item.empDetails,
                          ...item,
                        }));
                } else if (item.criterionType == "我们快速决策，卓越交付") {
                  hash[id]
                    ? (array[hash[id] - 1].expectDetails4 =
                        item.expectDetails) &&
                      (array[hash[id] - 1].dirSupFeedback4 =
                        item.dirSupFeedback) &&
                      (array[hash[id] - 1].empDetails4 = item.empDetails) &&
                      (array[hash[id] - 1].indirSupFeedback4 =
                        item.indirSupFeedback)
                    : (hash[id] =
                        ++i &&
                        array.push({
                          expectDetails4: item.expectDetails,
                          dirSupFeedback4: item.dirSupFeedback,
                          indirSupFeedback4: item.indirSupFeedback,
                          empDetails4: item.empDetails,
                          ...item,
                        }));
                } else if (
                  item.criterionType ==
                  "我们赋能、授权、支持和培养我们的员工，使其充分发挥潜力"
                ) {
                  hash[id]
                    ? (array[hash[id] - 1].expectDetails5 =
                        item.expectDetails) &&
                      (array[hash[id] - 1].dirSupFeedback5 =
                        item.dirSupFeedback) &&
                      (array[hash[id] - 1].empDetails5 = item.empDetails) &&
                      (array[hash[id] - 1].indirSupFeedback5 =
                        item.indirSupFeedback)
                    : (hash[id] =
                        ++i &&
                        array.push({
                          expectDetails5: item.expectDetails,
                          dirSupFeedback5: item.dirSupFeedback,
                          indirSupFeedback5: item.indirSupFeedback,
                          empDetails5: item.empDetails,
                          ...item,
                        }));
                }
              });
              this.dataGrowth = array;
              this.total = parseInt(res.pageInfo.total);
              this.dataGrowth = this.filterData(res.data);
            }
            if (Number(this.searchItem.year)  >= 2026) {
              this.dataGrowth26 = res.data || [];
              this.total = parseInt(res.pageInfo.total);
              this.setColumnsGrowthCulture26();
            }
          }
          this.$refs.FormComponent.prevent = false;
          this.loading = false;
        });
      }
    },
    filterData(arr) {
      // 常量提取到函数外部
      const TYPE_MAPPING = {
        "我们永怀炽热之心，不断追求卓越表现": "1",
        "我们营造一个充满正能量、具有同理心的工作环境": "2",
        我们所做的一切始终以消费者为中心: "3",
        "我们快速决策，卓越交付": "4",
        "我们赋能、授权、支持和培养我们的员工，使其充分发挥潜力": "5",
      };

      const PROPERTIES = [
        "expectDetails",
        "dirSupFeedback",
        "indirSupFeedback",
        "empDetails",
      ];

      // 提取处理函数
      function processPeoData(peoItem) {
        if (!peoItem || !Array.isArray(peoItem) || peoItem.length === 0) {
          return {};
        }

        const obj = JSON.parse(JSON.stringify(peoItem[0]));

        peoItem.forEach((pItem) => {
          const suffix = TYPE_MAPPING[pItem.criterionType];
          if (suffix) {
            PROPERTIES.forEach((prop) => {
              if (pItem[prop]) {
                obj[`${prop}${suffix}`] = pItem[prop];
              }
            });
          }
        });

        return obj;
      }
      // 使用 reduce 简化分组逻辑
      const peoObj = arr.reduce((acc, item) => {
        if (!acc[item.id]) {
          acc[item.id] = [];
        }
        acc[item.id].push(item);
        return acc;
      }, {});

      // 直接映射处理结果
      return Object.values(peoObj).map(processPeoData);
    },
    getFormData(item) {
      this.pageInfo.pageNo = 1;
      this.getData(item);
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData(JSON.stringify(this.searchItem));
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getData(JSON.stringify(this.searchItem));
    },
    exportData() {
      this.setColumnsGrowthCulture26();
      let obj = {
        serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
          .serialnumber,
        ...this.searchItem,
        pageNo: 1,
        pageSize: 99999,
      };
      this.loading = true;
      if (this.searchItem.year < "2025") {
        axios.post("/achReport/selectExpectInfo", obj).then((res) => {
          if (res) {
            let array = [];
            var hash = {};
            var i = 0;
            res.data.forEach(function (item) {
              var id = item.id;
              if (item.criterionType == "协同一致") {
                hash[id]
                  ? (array[hash[id] - 1].expectDetails1 = item.expectDetails) &&
                    (array[hash[id] - 1].dirSupFeedback1 =
                      item.dirSupFeedback) &&
                    (array[hash[id] - 1].indirSupFeedback1 =
                      item.indirSupFeedback)
                  : (hash[id] =
                      ++i &&
                      array.push({
                        expectDetails1: item.expectDetails,
                        dirSupFeedback1: item.dirSupFeedback,
                        indirSupFeedback1: item.indirSupFeedback,
                        ...item,
                      }));
              } else if (item.criterionType == "勇于承担") {
                hash[id]
                  ? (array[hash[id] - 1].expectDetails2 = item.expectDetails) &&
                    (array[hash[id] - 1].dirSupFeedback2 =
                      item.dirSupFeedback) &&
                    (array[hash[id] - 1].indirSupFeedback2 =
                      item.indirSupFeedback)
                  : (hash[id] =
                      ++i &&
                      array.push({
                        expectDetails2: item.expectDetails,
                        dirSupFeedback2: item.dirSupFeedback,
                        indirSupFeedback2: item.indirSupFeedback,
                        ...item,
                      }));
              } else {
                hash[id]
                  ? (array[hash[id] - 1].expectDetails3 = item.expectDetails) &&
                    (array[hash[id] - 1].dirSupFeedback3 =
                      item.dirSupFeedback) &&
                    (array[hash[id] - 1].indirSupFeedback3 =
                      item.indirSupFeedback)
                  : (hash[id] =
                      ++i &&
                      array.push({
                        expectDetails3: item.expectDetails,
                        dirSupFeedback3: item.dirSupFeedback,
                        indirSupFeedback3: item.indirSupFeedback,
                        ...item,
                      }));
              }
            });
            this.$nextTick(() => {
              this.$exportExcel(
                "tableRef",
                this.$t("Behavioural_Expectations") +
                  this.$nowDate.dateVal(new Date(), "YYYY-MM-DD HH-mm"),
                array
              );
            });
            this.loading = false;
          }
        });
      }
      // if (["2025", "2026"].includes(this.searchItem.year)) {
      if (Number(this.searchItem.year) > 2024) {
        axios.post("/achReport/selectGrowthInfo", obj).then((res) => {
          if (res) {
            if (this.searchItem.year == "2025") {
              let list = res.data;
              let array = [];
              var hash = {};
              var i = 0;
              list.forEach(function (item) {
                var id = item.id;
                if (
                  item.criterionType == "我们永怀炽热之心，不断追求卓越表现"
                ) {
                  hash[id]
                    ? (array[hash[id] - 1].expectDetails1 =
                        item.expectDetails) &&
                      (array[hash[id] - 1].dirSupFeedback1 =
                        item.dirSupFeedback) &&
                      (array[hash[id] - 1].empDetails1 = item.empDetails) &&
                      (array[hash[id] - 1].indirSupFeedback1 =
                        item.indirSupFeedback)
                    : (hash[id] =
                        ++i &&
                        array.push({
                          expectDetails1: item.expectDetails,
                          dirSupFeedback1: item.dirSupFeedback,
                          indirSupFeedback1: item.indirSupFeedback,
                          empDetails1: item.empDetails,
                          ...item,
                        }));
                } else if (
                  item.criterionType ==
                  "我们营造一个充满正能量、具有同理心的工作环境"
                ) {
                  hash[id]
                    ? (array[hash[id] - 1].expectDetails2 =
                        item.expectDetails) &&
                      (array[hash[id] - 1].dirSupFeedback2 =
                        item.dirSupFeedback) &&
                      (array[hash[id] - 1].empDetails2 = item.empDetails) &&
                      (array[hash[id] - 1].indirSupFeedback2 =
                        item.indirSupFeedback)
                    : (hash[id] =
                        ++i &&
                        array.push({
                          expectDetails2: item.expectDetails,
                          dirSupFeedback2: item.dirSupFeedback,
                          indirSupFeedback2: item.indirSupFeedback,
                          empDetails2: item.empDetails,
                          ...item,
                        }));
                } else if (
                  item.criterionType == "我们所做的一切始终以消费者为中心"
                ) {
                  hash[id]
                    ? (array[hash[id] - 1].expectDetails3 =
                        item.expectDetails) &&
                      (array[hash[id] - 1].dirSupFeedback3 =
                        item.dirSupFeedback) &&
                      (array[hash[id] - 1].empDetails3 = item.empDetails) &&
                      (array[hash[id] - 1].indirSupFeedback3 =
                        item.indirSupFeedback)
                    : (hash[id] =
                        ++i &&
                        array.push({
                          expectDetails3: item.expectDetails,
                          dirSupFeedback3: item.dirSupFeedback,
                          indirSupFeedback3: item.indirSupFeedback,
                          empDetails3: item.empDetails,
                          ...item,
                        }));
                } else if (item.criterionType == "我们快速决策，卓越交付") {
                  hash[id]
                    ? (array[hash[id] - 1].expectDetails4 =
                        item.expectDetails) &&
                      (array[hash[id] - 1].dirSupFeedback4 =
                        item.dirSupFeedback) &&
                      (array[hash[id] - 1].empDetails4 = item.empDetails) &&
                      (array[hash[id] - 1].indirSupFeedback4 =
                        item.indirSupFeedback)
                    : (hash[id] =
                        ++i &&
                        array.push({
                          expectDetails4: item.expectDetails,
                          dirSupFeedback4: item.dirSupFeedback,
                          indirSupFeedback4: item.indirSupFeedback,
                          empDetails4: item.empDetails,
                          ...item,
                        }));
                } else if (
                  item.criterionType ==
                  "我们赋能、授权、支持和培养我们的员工，使其充分发挥潜力"
                ) {
                  hash[id]
                    ? (array[hash[id] - 1].expectDetails5 =
                        item.expectDetails) &&
                      (array[hash[id] - 1].dirSupFeedback5 =
                        item.dirSupFeedback) &&
                      (array[hash[id] - 1].empDetails5 = item.empDetails) &&
                      (array[hash[id] - 1].indirSupFeedback5 =
                        item.indirSupFeedback)
                    : (hash[id] =
                        ++i &&
                        array.push({
                          expectDetails5: item.expectDetails,
                          dirSupFeedback5: item.dirSupFeedback,
                          indirSupFeedback5: item.indirSupFeedback,
                          empDetails5: item.empDetails,
                          ...item,
                        }));
                }
              });
              this.$nextTick(() => {
                this.$exportExcel(
                  "tableGrowthRef",
                  this.$t("Behavioural_Expectations") +
                    this.$nowDate.dateVal(new Date(), "YYYY-MM-DD HH-mm"),
                  this.filterData(res.data)
                );
              });
            }
            if (this.searchItem.year == "2026") {
              this.$nextTick(() => {
                this.$exportExcel(
                  "tableGrowth26Ref",
                  this.$t("Behavioural_Expectations") +
                    this.$nowDate.dateVal(new Date(), "YYYY-MM-DD HH-mm"),
                  res.data
                );
              });
            }
            this.loading = false;
          }
        });
      }

      // this.$refs.table.exportCsv({
      //     filename: '行为期望'
      // });
    },
    checkBtn(row, index) {
      const href =
        "/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27/?id=" +
        row.id +
        "&serialnumber=" +
        row.serialnumber +
        "&year=" +
        row.year +
        "&userName=" +
        row.userName +
        "&returnFlag='1'";
      window.open(href, "_blank");
      // this.$router.push({
      //   path: "/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27",
      //   query: { id: row.id, serialnumber: row.serialnumber, year: row.year }
      // });
    },
    handleReset() {
      this.searchItem.year = this.date.dateVal(new Date(), "YYYY");
      // this.pageInfo.pageNo=1
      // this.getData(JSON.stringify(this.formItem))
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/BehaviorExpectation.vue